<div class="dash-container">
    <h1 class="welcome-text">Benvenuto a MrSMS</h1>
</div>